const publicRoutes = new Set(['login', 'password-reset', 'request-access', 'auth-callback', 'world'])

export const isPublicRoute = (name: unknown): boolean => publicRoutes.has(String(name ?? ''))
